// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"15d8c188","239":"2573fd5e","453":"edb4e1ec","455":"b68337fe"}[chunkId] + ".chunk.js";
};